import { useState, useEffect } from 'preact/hooks';

interface Book {
  id: number;
  title: string;
  permalink: string;
  description: string;
  coverImageThumb: string | null;
  coverImageMed: string | null;
  coverImageFull: string | null;
  tags: string[] | null;
  meanRating: number | null;
  totalReviews: number | null;
  wordCount: number | null;
  chapterCount: number | null;
  author: Record<string, any>;
  lastUpdated: string;
}

interface UseFeaturedBooksResult {
  books: Book[];
  loading: boolean;
  error: string | null;
}

export const useFeaturedBooks = (limit: number = 48): UseFeaturedBooksResult => {
  const [books, setBooks] = useState<Book[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchFeaturedBooks = async () => {
      try {
        setLoading(true);
        const response = await fetch(`/api/v0/random-featured-books?limit=${limit}`);
        
        if (!response.ok) {
          throw new Error(`Failed to fetch featured books: ${response.status} ${response.statusText}`);
        }
        
        const data = await response.json();
        setBooks(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch featured books');
      } finally {
        setLoading(false);
      }
    };

    fetchFeaturedBooks();
  }, [limit]);

  return { books, loading, error };
};
